import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
// Layouts for different user roles
import MartLayout from "./Layouts/MartLayout"; 
import VendorLayout from "./Layouts/VendorLayout"; 
import AdminLayout from "./Layouts/AdminLayout";
import ArchitectureLayout from "./Layouts/ArchitectureLayout";
import ContractorLayout from "./Layouts/ContractorLayout"; 

// Mart pages
import Home from "./pages/Mart/Home";
import MartLogin from "./pages/Mart/MartLogin";
import ProductCategorie from "./pages/Mart/Products/ProductCategorie";
import ProductView from "./pages/Mart/Products/ProductView";
import MartOrders from "./pages/Mart/Orders/MartOrders";
import Profile from "./Components/Mart/Profile";  

// Vendor pages
import VendorDashboard from "./pages/Vendor/VendorDashboard";
import AddProduct from "./pages/Vendor/Products/AddProducts";
import ViewProducts from "./pages/Vendor/Products/ViewProducts";
import VendorNewOrders from "./pages/Vendor/Orders/NewOrders";
import VendorAcceptedOrders from "./pages/Vendor/Orders/AcceptedOrders";
import VendorOutForDelivery from "./pages/Vendor/Orders/OutForDelivery";
import VendorDeliveredOrders from "./pages/Vendor/Orders/DeliveredOrders";
import VendorCancelledOrders from "./pages/Vendor/Orders/CanceledOrders";

//architecture pages
import ArchitectureHome from "./pages/Architecture/ArchitectureHome";
import ArchitectLogin from "./pages/Architecture/ArchitectureLogin";
import ArchitectDashboard from "./pages/Architecture/AdminDashboard";
import ArchitectureAddProductForm from "./pages/Architecture/Products/AddProduct";
import ArchitectViewProducts from "./pages/Architecture/Products/ViewProduct";
import ArchitectureNewOrders from "./pages/Architecture/Orders/NewOrders";
import ArchitectureAcceptedOrders from "./pages/Architecture/Orders/AcceptedOrders";
import ArchitectureOutForDelivery from "./pages/Architecture/Orders/OutForDelivery";
import ArchitectureDeliveredOrders from "./pages/Architecture/Orders/DeliveredOrders";
import ArchitectureCancelledOrders from "./pages/Architecture/Orders/CanceledOrders";

// Contractor pages
import ContractorHome from "./pages/Contractor/ContractorHome";
import ContractorLogin from "./pages/Contractor/ContractorLogin";
import ContractorDashboard from "./pages/Contractor/AdminDashboard";
import ContractorNewRequests from "./pages/Contractor/NewRequests";

// Admin pages
import AdminDashboard from "./pages/Admin/AdminDashboard";

// General pages
import VendorLogin from "./pages/Vendor/VendorLogin";
import AdminLogin from "./pages/Admin/AdminLogin";

// Protected routes
import { AdminProtectedRoute, VendorProtectedRoute ,ArchitectProtectedRoute ,ContractorProtectedRoute } from "./Components/ProtectedRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/vendor-login" element={<VendorLogin />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/mart-login" element={<MartLogin />} />
        <Route path="/architecture" element={<ArchitectureHome />} />
        <Route path="/architecture-login" element={<ArchitectLogin />} />
        <Route path="/contractor" element={<ContractorHome />} />
        <Route path="/contractor-login" element={<ContractorLogin />} />

        {/* Mart protected routes */}
        <Route element={<MartLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/products-categorie/:category" element={<ProductCategorie />} />
          <Route path="/vendor/:vendorId/products/:category/:productId" element={<ProductView />} />
          <Route path="/mart-orders" element={<MartOrders />} />
          <Route path="/profile" element={<Profile />} />
        </Route>

        {/* Vendor protected routes */}
        <Route element={<VendorProtectedRoute />}>
          <Route element={<VendorLayout />}>
            <Route path="/vendor" element={<VendorDashboard />} />
            {/* Products */}
            <Route path="/vendor/products/add" element={<AddProduct />} />
            <Route path="/vendor/products/view" element={<ViewProducts />} />
            {/* Orders */}
            <Route path="/vendor/orders/new" element={<VendorNewOrders />} />
            <Route path="/vendor/orders/accepted" element={<VendorAcceptedOrders />} />
            <Route path="/vendor/orders/delivery" element={<VendorOutForDelivery />} />
            <Route path="/vendor/orders/delivered" element={<VendorDeliveredOrders />} />
            <Route path="/vendor/orders/cancelled" element={<VendorCancelledOrders />} />
          </Route>
        </Route>

        {/* Architect protected routes */}
        <Route element={<ArchitectProtectedRoute />}>
          <Route element={<ArchitectureLayout />}>
            <Route path="/architect/dashboard" element={<ArchitectDashboard />} />
            <Route path="/architecture/products/add" element={<ArchitectureAddProductForm />} />
            <Route path="/architecture/products/view" element={<ArchitectViewProducts />} />
            {/* Orders */}
            <Route path="/architecture/orders/new" element={<ArchitectureNewOrders />} />
            <Route path="/architecture/orders/accepted" element={<ArchitectureAcceptedOrders />} />
            <Route path="/architecture/orders/delivery" element={<ArchitectureOutForDelivery />} />
            <Route path="/architecture/orders/delivered" element={<ArchitectureDeliveredOrders />} />
            <Route path="/architecture/orders/cancelled" element={<ArchitectureCancelledOrders />} />
          </Route>
        </Route>

         {/* Contractor protected routes */}
        <Route element={<ContractorProtectedRoute />}>
          <Route element={<ContractorLayout />}>
            <Route path="/contractor/dashboard" element={<ContractorDashboard />} />
            <Route path="/contractor/projects/new-requests" element={<ContractorNewRequests />} />
          </Route>
        </Route>


        {/* Admin protected routes */}
        <Route element={<AdminProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
          </Route>
        </Route>

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;